import styled from '@emotion/styled';

export const LisiniH1 = styled('div')({
  width: '30%',
  fontFamily: 'Menlo',
  margin: '0 auto'
});

export const Header = styled('div')({
  width: '100%',
  height: '100%'
});

export const LisiniFlex = styled('div')({
  display: 'flex',
  justifyContent: 'space-around',
  textAlign: 'center'
});

export const Big = styled('h1')({
  lineHeight: 2
});
